import { ReactNode, useLayoutEffect } from "react";
import { usePageLoader } from "../contexts/page_content_context";
import { createPortal } from 'react-dom';

/**
 * ContentBar
 */

type Props = {}

export const PageTopBar = ({ children }: React.PropsWithChildren<Props>) => {
  const { setPageActionBarVisibility } = usePageLoader();

  useLayoutEffect(() => {
    setPageActionBarVisibility(true);
    return () => setPageActionBarVisibility(false);
  }, [
    children,
    setPageActionBarVisibility,
  ]);

  const parentContainer = document.getElementById('page-actions-portal');
  if (!parentContainer) return null;
  return createPortal(children, parentContainer as any);
}

/**
 * ThreeSlotLayout
 */

type ThreeSlotLayoutProps = {
  leftSlotProps?: React.ComponentPropsWithoutRef<'div'>,
  centerSlotProps?: React.ComponentPropsWithoutRef<'div'>,
  rightSlotProps?: React.ComponentPropsWithoutRef<'div'>,
  leftSlot?: ReactNode,
  centerSlot?: ReactNode,
  rightSlot?: ReactNode,
}

export const ThreeSlotLayout = ({
  leftSlotProps,
  centerSlotProps,
  rightSlotProps,
  leftSlot,
  centerSlot,
  rightSlot,
}: ThreeSlotLayoutProps) => {
  return (
    <div className="w-full flex flex-col justify-between items-center">
      <div className="w-full flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
        <div className="flex-1 flex flex-row justify-start" {...leftSlotProps}>
          {leftSlot}
        </div>

        <div className="flex-1 flex flex-row justify-center" {...centerSlotProps}>
          {centerSlot}
        </div>

        <div className="flex-1 flex flex-row justify-end" {...rightSlotProps}>
          {rightSlot}
        </div>
      </div>
    </div>
  );
}


/**
 * TwoSlotLayout
 */

type TwoSlotLayoutProps = {
  leftSlotProps?: React.ComponentPropsWithoutRef<'div'>,
  rightSlotProps?: React.ComponentPropsWithoutRef<'div'>,
  leftSlot?: ReactNode,
  rightSlot?: ReactNode,
}

export const TwoSlotLayout = ({
  leftSlotProps,
  rightSlotProps,
  leftSlot,
  rightSlot,
}: TwoSlotLayoutProps) => {
  return (
    <div className="w-full flex flex-col justify-between items-center">
      <div className="w-full flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
        <div className="flex flex-row justify-start" {...leftSlotProps}>
          {leftSlot}
        </div>

        <div className="flex flex-row justify-end" {...rightSlotProps}>
          {rightSlot}
        </div>
      </div>
    </div>
  );
}
